import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

// HTML inside the Markdown is disabled, so the model cannot inject markup; the rendered output is then sanitized.
const md = new MarkdownIt({ html: false, linkify: true, breaks: true });

// Links open in a new tab and never carry window.opener.
const defaultLinkOpen =
	md.renderer.rules.link_open || ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));
md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
	tokens[idx].attrSet("target", "_blank");
	tokens[idx].attrSet("rel", "noopener noreferrer");
	return defaultLinkOpen(tokens, idx, options, env, self);
};

// Keeps a temperature on one line: "275 F (135 C)" never breaks before a unit or between the two units, so a
// narrow table column wraps between values instead of leaving "C)" on a line of its own.
const UNIT_GAP = /(\d)[ \t]+(°?[FC])(?=[\s).,;:|]|$)/g;
const UNITS_PAIR = /(\d[ \u00a0]?°?[FC])[ \t]+\((?=[\d-])/g;
function keepTemperaturesTogether(text) {
	return text.replace(UNIT_GAP, "$1\u00a0$2").replace(UNITS_PAIR, "$1\u00a0(");
}

export function renderAssistantMarkdown(text) {
	if (!text) return "";
	return DOMPurify.sanitize(md.render(keepTemperaturesTogether(text)), {
		USE_PROFILES: { html: true },
		ADD_ATTR: ["target"],
	});
}
